export default {
  ADD_COUNT_OF_ENTITIES (state, { entity, count }) {
    state.countData[entity] = count
  },
  ADD_RECENT_ENTITIES (state, { entity, data }) {
    state.recentEntities[entity] = data
  }
}



// WEBPACK FOOTER //
// ./src/modules/stats/store/mutations.js